import { BaseCarousel, type BaseCarouselConfig, type CarouselInstance } from './base-carousel';

export class ResponsiveCarousel extends BaseCarousel {
  private readonly selector: string = '.carousel__container__responsive';
  
  protected getDefaultConfig(): BaseCarouselConfig {
    return {
      slidesPerView: 1,
      spaceBetween: 20,
      loop: true,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      pagination: true,
      navigation: true,
      breakpoints: {
        768: {
          slidesPerView: 2,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 3,
          spaceBetween: 20,
        }
      },
    };
  }

  public init(): void {
    super.init(this.selector);
  }

  protected destroyCarousel(carouselInstance: CarouselInstance): void {
    super.destroyCarousel(carouselInstance);
    this.removeSwiperStructure(carouselInstance.container);
  }
}

// Create singleton instance
const responsiveCarousel = new ResponsiveCarousel();

export { responsiveCarousel };
